import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Currencies from '../../components/Currencies';
import { serverRequestPost, serverRequestPut, serverRequestDelete } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';
import { validateForm } from '../../utils/validations';
import { isForeignCompany } from '../../utils/companies';
import { TRANSLATION_FILES } from '../../constants/translation';

class CurrencySettings extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
    data: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    loading: PropTypes.bool,
    token: PropTypes.string,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const auth = props.auth;
    const data = props.data || [];
    return {
      auth,
      data,
      loading,
    };
  }
  constructor(props) {
    // TODO: test on other company to see if it loads other company currencies
    super(props);
    const state = CurrencySettings.getPropsToState(props);
    this.state = {
      ...state,
      genericErrMsg: props.t('An error occurred, please refresh page'),
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = CurrencySettings.getPropsToState(nextProps);
    this.setState({
      ...state,
    });
  }
  getCompanyDefaultCurrency() {
    const { companyCurrency = [] } = this.props.auth.company;
    const currency = companyCurrency.find(c => c.isDefault) || {};
    return currency.code || '';
  }
  async handleAdd(validations, { value }) {
    const { data, genericErrMsg } = this.state;
    const { store } = this.context;
    if (validateForm(store, validations)) return;
    await this.setLoading(true);
    try {
      const response = await serverRequestPost(
        `/company/${this.state.auth.company.id}/currency/`,
        store,
        this.props.token,
        value,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      data.push(response.data);
      this.setState({ data });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  handleDelete = async (e, { value }) => {
    await this.setLoading(true);
    const { data, genericErrMsg } = this.state;
    const { store } = this.context;
    const indexToBeDeleted = data.findIndex(val => val.code === value.code);
    if (indexToBeDeleted === -1) {
      this.handleError(store, genericErrMsg);
      return;
    }

    try {
      const response = await serverRequestDelete(
        `/company/${this.state.auth.company.id}/currency/${value.id}/`,
        store,
        this.props.token,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      data.splice(indexToBeDeleted, 1);
      this.setState({ data });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  async handleSave(validations, { value }) {
    const { data, genericErrMsg } = this.state;
    const { store } = this.context;
    if (validateForm(store, validations)) return;

    await this.setLoading(true);
    const i = data.findIndex(val => (val.code === value.code && val.id === value.id));
    if (i === -1) {
      this.handleError(store, genericErrMsg);
      return;
    }

    // only allow update conversion rate
    data[i].conversionRatePoint = value.conversionRatePoint;

    try {
      const response = await serverRequestPut(
        `/company/${this.state.auth.company.id}/currency/${value.id}/`,
        store,
        this.props.token,
        { conversionRatePoint: value.conversionRatePoint },
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      this.setState({ data });
      await this.setLoading(false);
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  render() {
    const { auth } = this.props;
    return (
      <Currencies
        companyDefaultCurrency={this.getCompanyDefaultCurrency()}
        isForeignCompany={auth && isForeignCompany(auth.company)}
        data={this.state.data || []}
        loading={this.state.loading}
        onDefaultAdd={(v, d) => {
          this.handleAdd(v, d);
        }}
        onDefaultDelete={(e, d) => {
          this.handleDelete(e, d);
        }}
        onDefaultSave={(v, d) => {
          this.handleSave(v, d);
        }}
      />
    );
  }
}

export default withTranslation(TRANSLATION_FILES.translation)(connect(CurrencySettings.mapStateToProps)(CurrencySettings));



// WEBPACK FOOTER //
// ./src/containers/CompanyCurrencies/CurrencySettings.jsx